var _title, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMir = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 134 38"
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", {
  id: "provider-mir"
}, "Mir")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M96.6 17.18V38h11.56V25.66h13.1a12.83 12.83 0 0 0 12-8.48z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M95.06 0c.68 8.5 8.73 15.23 18.55 15.23h20.09a12.6 12.6 0 0 0 .23-2.41A12.81 12.81 0 0 0 121.22 0z",
  opacity: 0.68
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M78 15a.7.7 0 0 1 1.31.31v22.5h11.52V0H79.27a4.65 4.65 0 0 0-3.74 2.45l-9.19 19.76a.7.7 0 0 1-.09.23.8.8 0 0 1-.64.33.78.78 0 0 1-.77-.77V0H53.29v37.81h11.55a4.67 4.67 0 0 0 3.68-2.45L78 15.09v-.05zm-43.19.69-6.76 22.12h-8.32L13 15.67a.76.76 0 0 0-1.5.14v22H-.07V0H12.8a5.54 5.54 0 0 1 5 3.68l5.62 18.41c.29.93.73.91 1 0L30 3.68A5.5 5.5 0 0 1 35 0h12.87v37.79H36.32v-22a.75.75 0 0 0-.76-.75.79.79 0 0 0-.75.65"
})));
export { SvgMir as ReactComponent };